import React, {useState} from "react";
import "./index.scss";
import {connect} from "react-redux";
import {notificationCountData, notificationCountLoadingSelector} from "store/reducer/notifications/count/selectors";
import {notificationCountStart} from "store/reducer/notifications/count/reducer";
import {Icon} from "features/components/icon";
import {NotificationsModalPortal} from "features/modals/notifications";

/* istanbul ignore next */
const mapStateToProps = state => ({
    count: notificationCountData(state),
    loading: notificationCountLoadingSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    notificationCountStart
};

export const NotificationButton = (props) => {
    const {count, loading} = props;
    const {notificationCountStart} = props;

    const [showModal, setShowModal] = useState(false);

    React.useEffect(() => {
        notificationCountStart()
    }, [notificationCountStart]);
    return <>
    <div className={`notification-button`} onClick={() => setShowModal(true)}>
        {count > 0 && <span className={"has-new"} />}
        {loading && <span className="loader-span"><Icon>loader</Icon></span>}
        <Icon>notification</Icon>
    </div>
    {showModal && <NotificationsModalPortal onClose={() => setShowModal(false)} />}
    </>;
};
export default connect(mapStateToProps, mapDispatchToProps)(NotificationButton);